import React, { useMemo } from 'react'
import { ActionList, ActionListItemProps, Avatar, Highlight } from '@node-space/ui-components'
import { Application } from 'types/customers'
import { statusVariantMap } from '../utils/utils'

export interface ApplicationItemsProps {
  applications: Application[]
}

export const ApplicationItems = ({ applications }: ApplicationItemsProps) => {
  const items: ActionListItemProps[] = useMemo(
    () =>
      applications?.map(({ id, externalReference, status, customerType, users }) => ({
        transparent: true,
        key: id,
        id,
        testId: `application-${id}`,
        Avatar: <Avatar type="entity" name={externalReference || id} />,
        title: externalReference || id,
        ...(users?.[0]?.email && { BodyPre: users[0].email }),
        HeaderHighlightLeft: <Highlight variant="emphasis">{customerType}</Highlight>,
        ActionHighlight: (
          <Highlight {...(statusVariantMap[status] && { type: statusVariantMap[status] })}>
            {status}
          </Highlight>
        ),
      })),
    [applications]
  )

  return <ActionList id="applications-list" items={items} />
}
